export var UiVoiceoverData: any =
    {
        "main-menu--recycling-adventure": {
            "start": 0.1,
            "length": 2.5
        },
        "main-menu--leaderboard": {
            "start": 2.9,
            "length": 1.4
        },
        "main-menu--play": {
            "start": 4.8,
            "length": 1.1
        },
        "main-menu--controls": {
            "start": 6.3,
            "length": 1.4
        },
        "main-menu--volume-on": {
            "start": 10.5,
            "length": 1
        },
        "main-menu--volume-off": {
            "start": 11.8,
            "length": 1
        },




        "difficulty--take-your-pick": {
            "start": 13.2,
            "length": 3
        },
        "difficulty--easy": {
            "start": 16.8,
            "length": 1
        },
        "difficulty--medium": {
            "start": 18.5,
            "length": 1.2
        },
        "difficulty--hard": {
            "start": 20.3,
            "length": 1.2
        },







        "instructions--0": {
            "start": 21.9,
            "length": 7.4
        },
        "instructions--1": {
            "start": 29.8,
            "length": 7.9
        },
        "instructions--2": {
            "start": 38.3,
            "length": 8.9
        },
        "instructions--3": {
            "start": 47.7,
            "length": 13.7
        },





        "gameplay--game-intro": {
            "start": 77.5,
            "length": 7.8
        },
        "gameplay--next-level-0": {
            "start": 121.5,
            "length": 3.2
        },
        "gameplay--next-level-1": {
            "start": 125.2,
            "length": 3.3
        },
        "gameplay--next-level-2": {
            "start": 129.0,
            "length": 1.8
        },
        "gameplay--pause": {
            "start": 131.3,
            "length": 1.4
        },
        "gameplay--continue": {
            "start": 133.3,
            "length": 1.2
        },
        "gameplay--quit": {
            "start": 135.0,
            "length": 1
        },
        "gameplay--game-over--out-of-time": {
            "start": 136.4,
            "length": 2.5
        },
        "gameplay--game-over--lost-control": {
            "start": 139.4,
            "length": 2.6
        },




        "sorting-game--intro-0": {
            "start": 85.9,
            "length": 2.1
        },
        "sorting-game--intro-1": {
            "start": 88.5,
            "length": 3.3
        },
        "sorting-game--intro-2": {
            "start": 92.3,
            "length": 5.5
        },
        "sorting-game--plastic": {
            "start": 98.3,
            "length": 0.7
        },
        "sorting-game--paper": {
            "start": 99.6,
            "length": 0.6
        },
        "sorting-game--glass": {
            "start": 100.7,
            "length": 0.7
        },
        "sorting-game--metal": {
            "start": 101.9,
            "length": 0.6
        },
        "sorting-game--non-recyclable": {
            "start": 103.0,
            "length": 1.1
        },




        "questions--intro": {
            "start": 104.4,
            "length": 3.3
        },
        "questions--correct-0": {
            "start": 108.2,
            "length": 1.3
        },
        "questions--correct-1": {
            "start": 110.0,
            "length": 1.3
        },
        "questions--correct-2": {
            "start": 111.8,
            "length": 1.3
        },
        "questions--incorrect-0": {
            "start": 113.6,
            "length": 2.1
        },
        "questions--incorrect-1": {
            "start": 116.2,
            "length": 2.3
        },
        "questions--incorrect-2": {
            "start": 119.0,
            "length": 2.1
        },





        "leaderboard--enter-your-initials": {
            "start": 142.6,
            "length": 1.8
        },
        "leaderboard--add-your-name": {
            "start": 144.9,
            "length": 2.1
        },
        "leaderboard--play-again": {
            "start": 147.5,
            "length": 1.4
        },
        "leaderboard--beat-that-score": {
            "start": 149.4,
            "length": 2.2
        },
        "leaderboard--beat your friends": {
            "start": 152.1,
            "length": 1.3
        },
        "leaderboard--want-to-play-again": {
            "start": 153.9,
            "length": 1.4
        },
        "back": {
            "start": 157.3,
            "length": 0.9
        },



        "question1--medium": {
            "start": 158.7,
            "length": 5.6
        },
        "question1--medium-answer-1": {
            "start": 164.9,
            "length": 1.0
        },
        "question1--medium-answer-2": {
            "start": 166.4,
            "length": 0.7
        },
        "question1--medium-answer-3": {
            "start": 167.5,
            "length": 0.7
        },


        "question2--medium": {
            "start": 168.7,
            "length": 1.7
        },
        "question2--medium-answer-1": {
            "start": 170.9,
            "length": 0.7
        },
        "question2--medium-answer-2": {
            "start": 172.1,
            "length": 0.6
        },
        "question2--medium-answer-3": {
            "start": 173.2,
            "length": 0.5
        },



        "question3--medium": {
            "start": 174.2,
            "length": 1.4
        },
        "question3--medium-answer-1": {
            "start": 176.2,
            "length": 0.4
        },
        "question3--medium-answer-2": {
            "start": 177.1,
            "length": 0.4
        },
        "question3--medium-answer-3": {
            "start": 178.1,
            "length": 0.5
        },


        "question4--medium": {
            "start": 179.1,
            "length": 3.0
        },
        "question4--medium-answer-1": {
            "start": 182.6,
            "length": 0.7
        },
        "question4--medium-answer-2": {
            "start": 183.8,
            "length": 0.8
        },
        "question4--medium-answer-3": {
            "start": 185.2,
            "length": 0.8
        },


        "question5--medium": {
            "start": 186.5,
            "length": 2.5
        },
        "question5--medium-answer-1": {
            "start": 189.5,
            "length": 0.6
        },
        "question5--medium-answer-2": {
            "start": 190.6,
            "length": 0.7
        },
        "question5--medium-answer-3": {
            "start": 191.7,
            "length": 0.7
        },


        "question6--medium": {
            "start": 192.9,
            "length": 3.2
        },
        "question6--medium-answer-1": {
            "start": 196.7,
            "length": 0.7
        },
        "question6--medium-answer-2": {
            "start": 197.9,
            "length": 0.6
        },
        "question6--medium-answer-3": {
            "start": 199.0,
            "length": 0.7
        },


        "question7--medium": {
            "start": 200.2,
            "length": 2.6
        },
        "question7--medium-answer-1": {
            "start": 203.3,
            "length": 0.8
        },
        "question7--medium-answer-2": {
            "start": 204.5,
            "length": 0.7
        },
        "question7--medium-answer-3": {
            "start": 205.7,
            "length": 0.9
        },


        "question8--medium": {
            "start": 207.1,
            "length": 4.2
        },
        "question8--medium-answer-1": {
            "start": 211.8,
            "length": 0.8
        },
        "question8--medium-answer-2": {
            "start": 213.1,
            "length": 0.7
        },
        "question8--medium-answer-3": {
            "start": 214.2,
            "length": 0.8
        },


        "question9--medium": {
            "start": 215.5,
            "length": 1.9
        },
        "question9--medium-answer-1": {
            "start": 217.9,
            "length": 0.7
        },
        "question9--medium-answer-2": {
            "start": 219.1,
            "length": 0.7
        },
        "question9--medium-answer-3": {
            "start": 220.3,
            "length": 0.8
        },


        "question10--medium": {
            "start": 221.6,
            "length": 4.3
        },
        "question10--medium-answer-1": {
            "start": 226.4,
            "length": 0.7
        },
        "question10--medium-answer-2": {
            "start": 227.7,
            "length": 0.6
        },
        "question10--medium-answer-3": {
            "start": 228.8,
            "length": 0.8
        },


        "question11--medium": {
            "start": 230.0,
            "length": 2.0
        },
        "question11--medium-answer-1": {
            "start": 232.5,
            "length": 1.0
        },
        "question11--medium-answer-2": {
            "start": 234.1,
            "length": 1.3
        },
        "question11--medium-answer-3": {
            "start": 235.9,
            "length": 0.9
        },


        "question12--medium": {
            "start": 237.3,
            "length": 2.0
        },
        "question12--medium-answer-1": {
            "start": 239.8,
            "length": 0.8
        },
        "question12--medium-answer-2": {
            "start": 241.1,
            "length": 1.3
        },
        "question12--medium-answer-3": {
            "start": 242.8,
            "length": 0.9
        },



        "question13--medium": {
            "start": 244.2,
            "length": 2.9
        },
        "question13--medium-answer-1": {
            "start": 247.6,
            "length": 0.5
        },
        "question13--medium-answer-2": {
            "start": 248.6,
            "length": 1.2
        },
        "question13--medium-answer-3": {
            "start": 250.4,
            "length": 0.6
        },


        "question14--medium": {
            "start": 251.4,
            "length": 3.0
        },
        "question14--medium-answer-1": {
            "start": 255.0,
            "length": 0.9
        },
        "question14--medium-answer-2": {
            "start": 256.4,
            "length": 0.9
        },
        "question14--medium-answer-3": {
            "start": 257.7,
            "length": 0.9
        },


        "question15--medium": {
            "start": 259.2,
            "length": 7.4
        },
        "question15--medium-answer-1": {
            "start": 267.1,
            "length": 0.7
        },
        "question15--medium-answer-2": {
            "start": 268.3,
            "length": 268.3
        },
        "question15--medium-answer-3": {
            "start": 269.5,
            "length": 0.8
        },


        "question16--medium": {
            "start": 270.8,
            "length": 5.2
        },
        "question16--medium-answer-1": {
            "start": 276.5,
            "length": 0.4
        },
        "question16--medium-answer-2": {
            "start": 277.4,
            "length": 0.4
        },
        "question16--medium-answer-3": {
            "start": 278.4,
            "length": 0.5
        },


        "question17--medium": {
            "start": 279.4,
            "length": 4.9
        },
        "question17--medium-answer-1": {
            "start": 284.7,
            "length": 1.0
        },
        "question17--medium-answer-2": {
            "start": 286.2,
            "length": 0.7
        },
        "question17--medium-answer-3": {
            "start": 287.4,
            "length": 0.9
        },


        "question18--medium": {
            "start": 288.8,
            "length": 2.9
        },
        "question18--medium-answer-1": {
            "start": 292.2,
            "length": 0.7
        },
        "question18--medium-answer-2": {
            "start": 293.4,
            "length": 0.9
        },
        "question18--medium-answer-3": {
            "start": 294.8,
            "length": 0.5
        },


        "question19--medium": {
            "start": 295.7,
            "length": 5.1
        },
        "question19--medium-answer-1": {
            "start": 301.3,
            "length": 0.4
        },
        "question19--medium-answer-2": {
            "start": 302.2,
            "length": 0.7
        },
        "question19--medium-answer-3": {
            "start": 303.4,
            "length": 0.5
        },


        "question20--medium": {
            "start": 304.4,
            "length": 2.1
        },
        "question20--medium-answer-1": {
            "start": 306.9,
            "length": 0.6
        },
        "question20--medium-answer-2": {
            "start": 308.1,
            "length": 0.5
        },
        "question20--medium-answer-3": {
            "start": 309.1,
            "length": 0.5
        },





        "question1--hard": {
            "start": 310.1,
            "length": 4.9
        },
        "question1--hard-answer-1": {
            "start": 315.5,
            "length": 0.8
        },
        "question1--hard-answer-2": {
            "start": 316.8,
            "length": 0.6
        },
        "question1--hard-answer-3": {
            "start": 317.9,
            "length": 0.8
        },


        "question2--hard": {
            "start": 319.2,
            "length": 2.7
        },
        "question2--hard-answer-1": {
            "start": 322.5,
            "length": 0.6
        },
        "question2--hard-answer-2": {
            "start": 323.6,
            "length": 0.6
        },
        "question2--hard-answer-3": {
            "start": 324.7,
            "length": 0.6
        },



        "question3--hard": {
            "start": 325.8,
            "length": 2.1
        },
        "question3--hard-answer-1": {
            "start": 328.4,
            "length": 0.5
        },
        "question3--hard-answer-2": {
            "start": 329.4,
            "length": 1.0
        },
        "question3--hard-answer-3": {
            "start": 330.8,
            "length": 0.8
        },


        "question4--hard": {
            "start": 332.2,
            "length": 1.6
        },
        "question4--hard-answer-1": {
            "start": 334.2,
            "length": 0.6
        },
        "question4--hard-answer-2": {
            "start": 335.3,
            "length": 0.4
        },
        "question4--hard-answer-3": {
            "start": 336.3,
            "length": 0.6
        },


        "question5--hard": {
            "start": 337.4,
            "length": 2.3
        },
        "question5--hard-answer-1": {
            "start": 340.1,
            "length": 0.5
        },
        "question5--hard-answer-2": {
            "start": 341.1,
            "length": 0.5
        },
        "question5--hard-answer-3": {
            "start": 342.1,
            "length": 0.6
        },


        "question6--hard": {
            "start": 343.2,
            "length": 2.3
        },
        "question6--hard-answer-1": {
            "start": 346.0,
            "length": 0.5
        },
        "question6--hard-answer-2": {
            "start": 347.1,
            "length": 0.6
        },
        "question6--hard-answer-3": {
            "start": 348.2,
            "length": 0.6
        },


        "question7--hard": {
            "start": 349.2,
            "length": 2.9
        },
        "question7--hard-answer-1": {
            "start": 352.6,
            "length": 0.7
        },
        "question7--hard-answer-2": {
            "start": 353.9,
            "length": 0.5
        },
        "question7--hard-answer-3": {
            "start": 354.8,
            "length": 0.6
        },


        "question8--hard": {
            "start": 355.9,
            "length": 3.1
        },
        "question8--hard-answer-1": {
            "start": 359.5,
            "length": 0.6
        },
        "question8--hard-answer-2": {
            "start": 360.6,
            "length": 0.6
        },
        "question8--hard-answer-3": {
            "start": 361.7,
            "length": 0.6
        },


        "question9--hard": {
            "start": 362.7,
            "length": 1.4
        },
        "question9--hard-answer-1": {
            "start": 364.6,
            "length": 0.4
        },
        "question9--hard-answer-2": {
            "start": 365.5,
            "length": 0.6
        },
        "question9--hard-answer-3": {
            "start": 366.6,
            "length": 0.7
        },


        "question10--hard": {
            "start": 367.8,
            "length": 2.1
        },
        "question10--hard-answer-1": {
            "start": 370.4,
            "length": 0.6
        },
        "question10--hard-answer-2": {
            "start": 371.5,
            "length": 0.5
        },
        "question10--hard-answer-3": {
            "start": 372.4,
            "length": 0.6
        },


        "question11--hard": {
            "start": 373.5,
            "length": 2.8
        },
        "question11--hard-answer-1": {
            "start": 376.8,
            "length": 0.8
        },
        "question11--hard-answer-2": {
            "start": 378.0,
            "length": 0.6
        },
        "question11--hard-answer-3": {
            "start": 379.1,
            "length": 0.4
        },


        "question12--hard": {
            "start": 380.0,
            "length": 2.9
        },
        "question12--hard-answer-1": {
            "start": 383.4,
            "length": 0.5
        },
        "question12--hard-answer-2": {
            "start": 384.4,
            "length": 0.9
        },
        "question12--hard-answer-3": {
            "start": 385.8,
            "length": 0.8
        },



        "question13--hard": {
            "start": 387.1,
            "length": 2.0
        },
        "question13--hard-answer-1": {
            "start": 389.6,
            "length": 1.3
        },
        "question13--hard-answer-2": {
            "start": 391.4,
            "length": 2.0
        },
        "question13--hard-answer-3": {
            "start": 394.0,
            "length": 1.0
        },


        "question14--hard": {
            "start": 395.4,
            "length": 3.8
        },
        "question14--hard-answer-1": {
            "start": 399.8,
            "length": 0.8
        },
        "question14--hard-answer-2": {
            "start": 401.1,
            "length": 0.9
        },
        "question14--hard-answer-3": {
            "start": 402.4,
            "length": 0.8
        },


        "question15--hard": {
            "start": 403.7,
            "length": 2.6
        },
        "question15--hard-answer-1": {
            "start": 406.7,
            "length": 0.6
        },
        "question15--hard-answer-2": {
            "start": 407.9,
            "length": 0.6
        },
        "question15--hard-answer-3": {
            "start": 409.0,
            "length": 0.9
        },


        "question16--hard": {
            "start": 410.3,
            "length": 2.8
        },
        "question16--hard-answer-1": {
            "start": 413.6,
            "length": 0.9
        },
        "question16--hard-answer-2": {
            "start": 415.0,
            "length": 1.6
        },
        "question16--hard-answer-3": {
            "start": 417.1,
            "length": 1.2
        },


        "question17--hard": {
            "start": 418.8,
            "length": 2.6
        },
        "question17--hard-answer-1": {
            "start": 421.9,
            "length": 0.5
        },
        "question17--hard-answer-2": {
            "start": 423.0,
            "length": 0.7
        },
        "question17--hard-answer-3": {
            "start": 424.2,
            "length": 0.8
        },


        "question18--hard": {
            "start": 425.5,
            "length": 3.0
        },
        "question18--hard-answer-1": {
            "start": 429.0,
            "length": 0.9
        },
        "question18--hard-answer-2": {
            "start": 430.4,
            "length": 0.9
        },
        "question18--hard-answer-3": {
            "start": 431.8,
            "length": 0.9
        },


        "question19--hard": {
            "start": 433.2,
            "length": 3.8
        },
        "question19--hard-answer-1": {
            "start": 437.4,
            "length": 0.5
        },
        "question19--hard-answer-2": {
            "start": 438.5,
            "length": 0.5
        },
        "question19--hard-answer-3": {
            "start": 439.7,
            "length": 0.5
        },


        "question20--hard": {
            "start": 440.6,
            "length": 3.5
        },
        "question20--hard-answer-1": {
            "start": 444.6,
            "length": 0.7
        },
        "question20--hard-answer-2": {
            "start": 445.8,
            "length": 0.6
        },
        "question20--hard-answer-3": {
            "start": 446.9,
            "length": 0.6
        }
    };


// WEBPACK FOOTER //
// ./src/ts/audio/voiceovers/VoiceOverData.ts